import { render, staticRenderFns } from "./chipPermisos.vue?vue&type=template&id=a3c049bc"
import script from "./chipPermisos.vue?vue&type=script&lang=js"
export * from "./chipPermisos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports